import React from 'react';
import { Close, Done } from '@gjensidige/core-icons';

interface CheckmarkProps {
  value: string | undefined;
  className?: string;
}

const Checkmark = ({ value, className }: CheckmarkProps) => {
  const getCheckmark = (value: string | undefined) => {
    if (value !== '') {
      if (value === 'Ja') {
        return <Done className={className} color="green" />;
      } else {
        return <Close className={className} color="red" />;
      }
    } else {
      return null;
    }
  };

  return getCheckmark(value);
};

export default Checkmark;
